import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import MyCoordinateFormDetail from '../../components/form/MyCoordinateFormDetail';
import MessageSuccess from '../../components/form/MessageSuccess';
import InformationsController from '../../controller/informations.controller';
import {WebEventUtil} from '../../util/web-event-util';
import {RawUpdateUserInformationRequest, UpdateUserInformationRequest, WebEventRequest} from '../../../typing';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import NoticeForList from "../../components/GIEList/NoticeForList";
import HeaderForm from "../../components/form/HeaderForm";
import GieCard from "../../components/GIECard/GieCard";

export default class MyCoordinateForm extends React.Component<any, any> {
  informationsController: InformationsController = new InformationsController();

  constructor(props: any) {
    super(props);
    this.state = {
      coordinateSend: false
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  changeForm = (form) => {
    let coordinate: any = {};
    Object.keys(form).forEach((name, key) => {
      coordinate[name] = form[name].value
    });
    const noContract = coordinate.noContract;
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      this.pushData(coordinate, noContract)
    }
  }

  pushData = (coordinate, noContract) => {
    const requestWebEvent: WebEventRequest = {
      noContrat: noContract,
      eventType: "3",
      eventCode: 'CHGADR',
      description: 'Mettre à jour mes coordonnées',
      confirm: '0',
      mail_object: WebEventUtil.getBodyOfEmail(coordinate),
      noClient: null,
      codeSite: null
    }

    const updateUserInformationRequest: UpdateUserInformationRequest = {
      lastName: coordinate.lastName || '',
      email: coordinate.email || '',
      phoneNumber: coordinate.phoneNumber || '',
      adresse: coordinate.adresse || '',
      adresse2: '',
      zipCode: coordinate.zipCode || '',
      city: coordinate.city || '',
      noClient: coordinate.noClient || '',
      noContract: coordinate.noContract || '',
      phoneMobile: coordinate.phoneMobile || '',
      phoneHome: coordinate.phoneHome || '',
      phoneOffice: coordinate.phoneOffice || '',
      shipToCode: null,
      name2: '',
      country: 'FR'
    }

    const request: RawUpdateUserInformationRequest = {
      updateUserInformationRequest: updateUserInformationRequest,
      webEventRequest: requestWebEvent
    }
    // this.webEventController.inserWebEvent(requestWebEvent).then((data)=>{
    //      this.setState({coordinateSend:true})
    // }).catch(err=>{
    //     console.log(err)
    // })
    this.informationsController.changeUserInformations(request).then(data => {
      this.setState({coordinateSend: true})
    }).catch(err => {
      console.log(err)
    })
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Mettre à jour mes coordonnées"
                                                                      href="coordonnees"
                                                                      title="Transmettez-nous votre demande"/>}>
          <div className="container-xl mb-5">
            <NoticeForList className="mb-3"
                           text="La mise à jour de vos coordonnées sera effective dès traitement de votre demande par nos services."
                           text2={
                             <span>Pour nous signaler un changement d’adresse, rendez-vous sur notre service <a
                               className="text-decoration-underline"
                               href='https://gie-sa.fr/services-en-ligne/je-demenage/'>Je déménage</a>, dans la rubrique Services en ligne.</span>}/>

            <GieCard width="100%" height="100%">
              {this.state.coordinateSend ? <MessageSuccess/> :
                <div>
                  <HeaderForm step={0} first="1 - Vos coordonnées"/>
                  <MyCoordinateFormDetail confidentiality
                                          changed
                                          buttonText="Valider"
                                          emit={this.changeForm}/>
                </div>
              }
            </GieCard>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
